import contentGetters from "./getters.js";
import contentMutations from "./mutations.js";
import contentActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      topicsloaded: null,
      subCategories: [
        { name: "Uncategorised", value: "SUBCAT_0000" },
        { name: "Getting Started", value: "SUBCAT_0001" },
        { name: "Basics", value: "SUBCAT_0002" },
        { name: "Intermediate", value: "SUBCAT_0003" },
        { name: "Advanced", value: "SUBCAT_0004" },
        { name: "Entry Instructions", value: "SUBCAT_0005" },
        { name: "Maintenance", value: "SUBCAT_0006" },
        { name: "Health and Safety", value: "SUBCAT_0007" },
        { name: "Code of Conduct", value: "SUBCAT_0008" },
      ],
      topics: [],
      categories: [],
      content: [],
    };
  },
  getters: contentGetters,
  mutations: contentMutations,
  actions: contentActions,
};
